import React, { useState, useEffect, useContext, useCallback } from "react";
import { withRouter, useHistory } from "react-router-dom";
import DispatchContext from "../../contexts/DispatchContext";
import StateContext from "../../contexts/StateContext";
import DataFetcher from "../../utils/DataFetcher";

import FormInstitution from "../forms/FormInstitution";
import LoadingIndicator from "../elements/LoadingIndicator";

import { getResponse, dispError, dispSuccess, getSalutation, getInterestGroup, getUserState, getRegion, renderLicencePie, renderLicenceTable, hasLicenceAssignmentData, renderLicenceAssignmentData } from "../../utils/Tools";

function Institution(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();
  const [editMode, setEditMode] = useState(false);
  const [institutionData, setData] = useState(null);
  const institutionID = props.match.params.id;

  const onDelete = id => {
    let confirm = window.confirm(getResponse("009a"));
    if (confirm) {
      DataFetcher.fetch(DataFetcher.INSTITUTION.DELETE, { _id: id })
        .then(response => {
          if (!response.success) {
            appDispatch(dispError(response.msg));
            return history.push("/");
          }
          appDispatch(dispSuccess(getResponse("009b")));
          return history.push("/institution/list");
        })
        .catch(error => {
          console.error(error);
          return history.push("/");
        });
    }
  };

  const onUpdate = () => {
    setEditMode(false);
    loadData();
  };

  // const sendActivationLink = e => {
  //   e.preventDefault();
  //   // Send activation link to client
  //   console.log(`Tell bridge to send institution ${institutionData._id} the link`);
  // };

  const loadData = useCallback(() => {
    DataFetcher.fetch(DataFetcher.INSTITUTION.DETAIL, { _id: institutionID })
      .then(response => {
        if (!response.success) {
          appDispatch(dispError(response.msg));
          return history.push("/institution/list");
        }
        return setData(response.institution);
      })
      .catch(error => {
        console.error(error);
        return history.goBack();
      });
  }, [institutionID, appDispatch, history]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  const showStatus = appState.user.navType === "lizensierender-mandant" ? false : true;

  return (
    <main className="institution content">
      {!institutionData && <LoadingIndicator />}
      {institutionData && (
        <>
          <h1 className="title">Details: {institutionData.name}</h1>
          {editMode && (
            <FormInstitution
              prefill={institutionData}
              modus="edit"
              onCancel={e => {
                setEditMode(false);
              }}
              onUpdate={onUpdate}
            />
          )}
          {!editMode && (
            <>
              <p>
                <strong>Name:</strong> {institutionData.name}
                {institutionData.interestGroup !== "self" && (
                  <>
                    <br />
                    <strong>Interessengruppe:</strong> {getInterestGroup(institutionData.interestGroup)}
                  </>
                )}
                {showStatus && (
                  <>
                    <br />
                    <span className="client-status">
                      <strong>Status:</strong>{" "}
                      <span className="icon">
                        <i className={getUserState(institutionData.isActivated, Boolean(institutionData.isDeleted)).icon}></i>
                      </span>{" "}
                      {getUserState(institutionData.isActivated).text}
                      {/* {!institutionData.isActivated && (
                        <button className="button" type="button" onClick={sendActivationLink}>
                          Link zusenden
                        </button>
                      )} */}
                    </span>
                  </>
                )}
              </p>
              <hr />
              <p className="title is-5">Adresse</p>
              <p>
                {institutionData.address.co && institutionData.address.co !== "" && (
                  <>
                    {institutionData.address.co}
                    <br />
                  </>
                )}
                {institutionData.address.street}
                {institutionData.address.addition && institutionData.address.addition !== "" && (
                  <>
                    <br />
                    {institutionData.address.addition}
                  </>
                )}
                <br />
                {institutionData.address.zipCode} {institutionData.address.city}
                <br />
                {getRegion(institutionData.address.region)}
              </p>
              <hr />
              <p className="title is-5">Ansprechpartner</p>
              <p>
                {getSalutation(institutionData.contact.salutation)} {institutionData.contact.firstname} {institutionData.contact.lastname}
                <br />
                {institutionData.contact.email}
                {institutionData.contact.tel !== "" && (
                  <>
                    <br />
                    {institutionData.contact.tel}
                  </>
                )}
              </p>
              <hr />
              {institutionData.licences && institutionData.licences.total > 0 && (
                <>
                  <div className="licences-box">
                    <p className="title is-5">Lizenzen</p>
                    <div className="field field-body">
                      {renderLicencePie(institutionData.licences)}
                      <div className="licence-table">
                        {renderLicenceTable(institutionData.licences)}
                        {Boolean(institutionData.licences.expired) && (
                          <p>
                            <span className="tag is-light">Abgelaufene Lizenzen: {institutionData.licences.expired}</span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr />
                </>
              )}
              {institutionData.log && hasLicenceAssignmentData(institutionData.log) && renderLicenceAssignmentData(institutionData.log)}
              <div className="field field-body">
                <button
                  className="button"
                  onClick={e => {
                    history.goBack();
                  }}>
                  Zurück
                </button>
                {!Boolean(institutionData.isDeleted) && (
                  <>
                    <button
                      className="button is-success ml-2"
                      onClick={e => {
                        setEditMode(true);
                      }}>
                      Bearbeiten
                    </button>
                    {institutionData.interestGroup !== "self" && (
                      <button
                        className="button is-danger ml-2"
                        onClick={e => {
                          onDelete(institutionData._id);
                        }}>
                        Löschen
                      </button>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
    </main>
  );
}
export default withRouter(Institution);
